var _ = require('lodash');
var dd = require('../../../lib/dd');
var radio = require("react-pubsub-via-radio.js/radio");
var esUtils = require('../../../utils/esUtils');
var ErrorAlert = require('../../../widgets/ErrorAlert');
var LoadingBar = require('../../../widgets/LoadingBar');
var FormInputMixin = require('../FormInputMixin');
var RadioAjaxMixin = require('../../../utils/ServicesUtils').RadioAjaxMixin;

module.exports = {
	component: dd.createClass({
		mixins: [FormInputMixin, RadioAjaxMixin('getCaptchaURL')],
		__onChange: function(e){
			var ajax = this.state.getCaptchaURL;
			var data = ajax.data || {};

			this._input_newValue({
				key: data.key,
				input: e.target.value
			});
		},
		__RadioAjax_key_getCaptchaURL: function(){
			return 1;
		},
		componentDidMount: function(){
			radio('getCaptchaURL').broadcast();
		},
		__refresh: esUtils.wrapPreventDefault(function(){
			radio('getCaptchaURL').broadcast();
		}),
		render: function(){
			var ajax = this.state.getCaptchaURL;
			var field = this.props.field;
			var value = (this.props.value && this.props.value.input) || '';
			var field_path = this.props.field_path;

			if(ajax.error_message){
				return ErrorAlert({message: ajax.error_message});
			}
			if(ajax.waiting){
				return dd.div({className: ajax.waiting},
					LoadingBar()
				);
			}
			var data = ajax.data || {};

			return dd.div({style: {width: '200px'}},
				dd.img({src: data.url, style: {padding: '0 10px 5px 0'}}),
				dd.a({href: '#', onClick: this.__refresh}, dd.i({className: 'fa fa-refresh'})),
				dd.input({
					type: 'text',
					name: field_path,
					value: value,
					onChange: this.__onChange,
					className: 'form-control',
					placeholder: field.placeholder || null
				})
			);
		}
	}),
	validate: function(v){
		return _.isString(v && v.input) && v.input.length > 0 ? true : 'Please enter the text above';
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/Captcha.js
// module id = 185
// module chunks = 0 1 2 3 4